import script from "./SkypeMsgWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkypeMsgWindow.vue?vue&type=script&lang=ts&setup=true"

import "./SkypeMsgWindow.vue?vue&type=style&index=0&id=2cc194c2&lang=css"

const __exports__ = script;

export default __exports__